import React from 'react'
import { useTimelineStyles } from '~/crop/crop-schedule/hooks/use-timeline-styles'

const ANIMATION_DURATION_S = 0.3
const ARROW_Y = 3           // y in SVG coords (original: box top=-3, line y=6 → net 3)
const ARROW_HEIGHT = 1.5
const ARROW_TIP_OFFSET = 0.5

/**
 * Timeline Task Overlay
 *
 * Vertical line showing task filter cutoff date (hover preview) and
 * mask covering everything to the right of it.
 * Renders as native SVG elements inside the content SVG.
 *
 * Only visible when hovering over task list date offset buttons.
 */
export const TimelineTaskOverlay = ({ visible, x, width }) => {
  const { TaskOverlayStyles } = useTimelineStyles()
  const maskWidth = width - x

  if (!visible || x < 0 || maskWidth <= 0) return null

  return (
    <>
      {/* Mask — renders first so cutoff line and arrow sit on top */}
      <rect
        x={x}
        y={0}
        width={maskWidth}
        height="100%"
        fill={TaskOverlayStyles.mask}
        style={{
          filter: 'grayscale(0.5)',
          mixBlendMode: 'multiply',
          pointerEvents: 'none',
          transition: `x ${ANIMATION_DURATION_S}s, width ${ANIMATION_DURATION_S}s`,
        }}
      />

      {/* Cutoff line */}
      <line
        x1={x}
        y1={0}
        x2={x}
        y2="100%"
        stroke={TaskOverlayStyles.cutoffLine}
        strokeWidth={3}
        style={{
          pointerEvents: 'none',
          transition: `x1 ${ANIMATION_DURATION_S}s, x2 ${ANIMATION_DURATION_S}s`,
        }}
      />

      {/* Gap arrow — left edge to cutoff */}
      <defs>
        <marker
          id="arrowhead-right"
          markerWidth="10"
          markerHeight="10"
          refX="7"
          refY="5"
          orient="auto"
          markerUnits="userSpaceOnUse"
        >
          <path d="M 0 2 L 7 5 L 0 8 Z" fill={TaskOverlayStyles.cutoffLine} />
        </marker>
      </defs>
      <line
        x1={0}
        y1={ARROW_Y}
        x2={x - ARROW_TIP_OFFSET}
        y2={ARROW_Y}
        stroke={TaskOverlayStyles.cutoffLine}
        strokeWidth={ARROW_HEIGHT}
        markerEnd="url(#arrowhead-right)"
        style={{ pointerEvents: 'none' }}
      />
    </>
  )
}
